module.exports = __webpack_public_path__ + "img/brasserie.cf6ee62a.jpg";